<template>
  <div
    class="flex flex-col gap-3 p-3 md:p-6 rounded-xl relative"
    :class="course.is_published ? '' : 'bg-zinc-200/50'"
  >
    <div
      v-if="!course.is_published"
      class="rounded-full bg-primary text-white px-2 inline-flex gap-2 items-center font-semibold py-0.5 text-sm absolute top-3 left-3 z-10"
    >
      <Icon name="mdi-pencil-outline" />
      Draft
    </div>
    <ImagePB
      :id="course.id"
      :src="course.image"
      :alt="course.title"
      :collection-id="course.collectionId"
      class="w-full h-64 object-cover"
    />

    <div
      class="rounded-full bg-zinc-200 px-2 inline-flex gap-2 items-center font-semibold py-0.5 text-sm self-start mt-6"
    >
      <Icon name="mdi-clock-outline" />
      {{ course.duration }}
    </div>

    <h3 class="mt-1">{{ course.title }}</h3>
    <p v-if="!withoutPurchase" class="font-bold text-right text-lg">
      £{{ convertPenceToPounds(course.price) }}
      <span class="text-sm font-normal">{{ course.vat_rate ? `+ VAT` : '' }}</span>
    </p>
    <div v-if="!withoutPurchase" class="flex gap-3 flex-wrap justify-between mt-3">
      <UInputNumber v-model="quantity" :min="1" :max="1" />
      <CourseAddToCartButton :course="course" :quantity="quantity" />
    </div>
    <UButton
      label="View Course"
      size="xl"
      trailing-icon="mdi:arrow-right"
      class="cursor-pointer justify-between"
      variant="subtle"
      @click="goToCourse(course.slug)"
    />
  </div>
</template>

<script setup lang="ts">
const { course } = defineProps<{ course: CoursesRecord; withoutPurchase?: boolean }>()

const { goToCourse } = useCourse()
const quantity = ref(1)
</script>

<style scoped></style>
